import React from "react"

const Error = (props) => {
	return (<>{props.error ? props.error : ""}</>)
}

export default Error
